import { Users, Circle } from "lucide-react";

const ETAT_COLOR = { actif: "#2E8B7A", inactif: "#E49B1A", deconnecte: "#B3382C" };

export default function PresenceBar({ presence = [], connected }) {
  if (!presence.length) return null;
  return (
    <div className="card" data-testid="presence-bar"
      style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", marginBottom: 14, flexWrap: "wrap" }}>
      <Users size={15} />
      <span style={{ fontSize: ".82rem", fontWeight: 600 }}>
        {presence.length} personne{presence.length > 1 ? "s" : ""} consulte{presence.length > 1 ? "nt" : ""} cette opération
      </span>
      <span style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {presence.map((p) => (
          <span key={p.connId} data-testid={`presence-${p.userId}`}
            style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: ".78rem",
              background: "var(--sarcelle-p, #EAF3F4)", padding: "3px 9px", borderRadius: 20 }}>
            <Circle size={8} fill={ETAT_COLOR[p.etat] || "#2E8B7A"} color={ETAT_COLOR[p.etat] || "#2E8B7A"} />
            <b>{p.nom}</b>
            <span style={{ color: "var(--text-muted)" }}>· {p.role}</span>
          </span>
        ))}
      </span>
      <span style={{ marginLeft: "auto", fontSize: ".7rem", color: "var(--text-muted)" }}
        data-testid="presence-conn-state">
        {connected ? "temps réel actif" : "reconnexion…"}
      </span>
    </div>
  );
}
